import React from "react";

const RadioButton = ({
  preferenceOptions,
  name,
  onChange,
  value,
  layout,
  error,
}) => {
  const layoutClass =
    layout === "column"
      ? "flex-col space-y-4"
      : "sm:flex sm:items-center sm:space-y-0 sm:space-x-10";
  return (
    <div>
      <fieldset className="mt-4">
        <div className={`space-y-4 ${layoutClass}`}>
          {preferenceOptions.map((option) => (
            <div key={option.id} className="flex items-center">
              <input
                id={option.id}
                name={name}
                type="radio"
                checked={value === option.id}
                className="h-4 w-4 cursor-pointer border-divider text-primary-600 focus:ring-primary-600 dark:text-[#BA181B] dark:focus:ring-primary-400"
                value={option.id}
                onChange={() =>
                  onChange({ target: { name, value: option.id } })
                }
              />
              <label
                htmlFor={option.id}
                className="ml-3 block text-sm font-medium text-text-secondary"
              >
                {option.name}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
      {error && <span className="text-error-500 text-sm">{error}</span>}
    </div>
  );
};

export default RadioButton;
